import React, { useState, useEffect, useMemo } from "react";
import { Parallax } from "react-scroll-parallax";
import "./galeria.css";

// Hook para detectar si es móvil
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const getRandomClass = () => {
  const classes = [
    "random-style-1",
    "random-style-2",
    "random-style-3",
    "random-style-4",
    "random-style-5",
    "random-style-6",
  ];
  return classes[Math.floor(Math.random() * classes.length)];
};

const formatCategory = (category) =>
  category.charAt(0).toUpperCase() + category.slice(1).toLowerCase();

const Galeria = ({ dataGalery }) => {
  const isValidData = dataGalery?.categories && dataGalery?.images;

  const title = useMemo(
    () => (isValidData ? dataGalery.title : { h2: "", h3: "" }),
    [dataGalery, isValidData]
  );
  const categories = useMemo(
    () => (isValidData ? dataGalery.categories : []),
    [dataGalery, isValidData]
  );
  const images = useMemo(
    () => (isValidData ? dataGalery.images : {}),
    [dataGalery, isValidData]
  );

  const [selectedCategory, setSelectedCategory] = useState(() => {
    if (categories.length > 0) {
      return formatCategory(categories[0]);
    }
    return "";
  });

  useEffect(() => {
    if (categories.length > 0) {
      setSelectedCategory(formatCategory(categories[0]));
    }
  }, [categories]);

  const isMobile = useIsMobile();

  if (!isValidData) {
    return <div>Error: No se pudieron cargar los datos de la galería.</div>;
  }

  return (
    <div className="gallery-container container-fluid">
      <header className="gallery-header">
        <h2>{title.h2}</h2>
        <h3>{title.h3}</h3>
        <nav className="categories">
          {categories.map((category) => {
            const formatted = formatCategory(category);
            return (
              <button
                key={category}
                className={`category-button ${selectedCategory === formatted ? "active" : ""
                  }`}
                onClick={() => setSelectedCategory(formatted)}
              >
                {category}
              </button>
            );
          })}
        </nav>
      </header>

      <div className="image-gallery box" style={{ overflow: "hidden" }}>
        {images[selectedCategory] && images[selectedCategory].length > 0 ? (
          images[selectedCategory].map((image, index) => {
            const randomClass = getRandomClass();

            // Parallax solo en mobile
            const parallaxProps = isMobile
              ? {
                opacity: [0, 2],
                scale: [0.95, 1],
                shouldAlwaysCompleteAnimation: true,
              }
              : {};

            return (
              <Parallax key={image.id} {...parallaxProps}>
                <div
                  className={`image-item inner ${randomClass}`}
                  style={{
                    backgroundImage: `url(${image.src})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    transition: "transform 0.3s ease-out",
                  }}
                />
              </Parallax>
            );
          })
        ) : (
          <p>No hay imágenes disponibles para esta categoría.</p>
        )}
      </div>
    </div>
  );
};

export default Galeria;
